import React from "react";
import { formatINR } from "@/utils/goldSilverParser";
import { DecreaseArrowIcon, IncreaseArrowIcon } from "./Icons";

const GOLD_CARATS = ["24", "22", "18", "14"];
const SILVER_WEIGHTS = [
    { key: "oneGram", label: "1 ग्राम" },
    { key: "tenGram", label: "10 ग्राम" },
    { key: "hundredGram", label: "100 ग्राम" },
    { key: "oneKg", label: "1000 ग्राम" },
];

function TrendValue({ isUp, amount }) {
    if (amount == null) return "-";
    return (
        <span className={`inline-flex items-center gap-1 font-medium ${isUp ? "text-green-600" : "text-red-500"}`}>
            {isUp ? <IncreaseArrowIcon /> : <DecreaseArrowIcon />}
            ₹{Math.abs(amount)} {isUp ? "की बढ़त" : "की गिरावट"}
        </span>
    );
}

export const PriceInfoTable = ({ city, currentRates, historyData, type = "gold", colors = {} }) => {
    const isGold = type === "gold";
    const cityName = city ? city.charAt(0).toUpperCase() + city.slice(1) : "";

    const rows = isGold
        ? GOLD_CARATS.map((carat) => ({
            label: `${cityName} में ${carat} कैरेट सोने का भाव`,
            value: `${formatINR(currentRates?.oneGram?.[`carat${carat}`])} प्रति ग्राम`,
        }))
        : SILVER_WEIGHTS.map(({ key, label }) => ({
            label: `${cityName} में ${label} चांदी का भाव`,
            value: formatINR(currentRates?.[key]),
        }));

    rows.push({
        label: isGold ? "सोने की कीमत में बदलाव" : "चांदी की कीमत में बदलाव",
        value: (
            <TrendValue
                isUp={(isGold ? currentRates?.trend24 : currentRates?.trendOneKg) === "increase"}
                amount={isGold ? currentRates?.difference24 : currentRates?.differenceOneKg}
            />
        ),
    });
    rows.push({
        label: "पिछले 10 दिनों का सबसे ऊंचा भाव",
        value: formatINR(historyData?.maxRate),
    });
    rows.push({
        label: "पिछले 10 दिनों का सबसे कम भाव",
        value: formatINR(historyData?.minRate),
    });

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
                <thead className={colors.lightBg || "bg-[#fafafa]"}>
                    <tr>
                        <th className={`px-4 py-3 text-xs md:text-sm font-semibold border-b ${colors.border || "border-gray-200"} whitespace-nowrap text-left`}>
                            विवरण
                        </th>
                        <th className={`px-4 py-3 text-xs md:text-sm font-semibold border-b ${colors.border || "border-gray-200"} whitespace-nowrap text-left`}>
                            मूल्य / जानकारी
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr key={index} className={`border-b ${colors.border || "border-gray-200"} last:border-none hover:bg-gray-50`}>
                            <td className="px-4 py-3 text-xs md:text-sm text-left  font-semibold ">{row.label}</td>
                            <td className="px-4 py-3 text-xs md:text-sm text-left font-semibold ">{row.value}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
